import type { CityConfig } from "../city-template/types";

export const laytonUTConfig: CityConfig = {
  city: "Layton",
  state: "Utah",
  stateAbbr: "UT",
  slug: "layton",
  route: "/cities/layton",
  title: "Emergency Passport Layton, UT | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Layton, UT — as fast as 24 hours. Serving Davis County and the northern Wasatch Front. A+ BBB rated registered State Dept. courier serving Hill AFB and the Layton Hills area. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Layton, UT",
  heroSubtitle: "PCS orders to Germany through Hill AFB and your family's passports are expired? Business trip to Tokyo leaving in 8 days? Summer vacation to Cancun and you just noticed your passport expired last month? We help Layton residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Layton%20Utah%20Davis%20County%20with%20Wasatch%20Mountains%20in%20background%20suburban%20neighborhoods%20Layton%20Hills%20Mall%20commercial%20district%20Great%20Salt%20Lake%20visible%20in%20distance%20Hill%20Air%20Force%20Base%20area%20wide%20green%20valleys%20golden%20hour%20warm%20summer%20light%20professional%20photography%20northern%20Utah%20landscape&width=1800&height=700&seq=layton-ut-hero-2026&orientation=landscape",
  heroImageAlt: "Layton Utah Davis County with Wasatch Mountains and Great Salt Lake at golden hour",
  geoPosition: "41.0602;-111.9711",
  geoPlacename: "Layton, Utah",
  regionalAgency: {
    name: "Denver Passport Agency",
    address: "3151 S Vaughn Way, Suite 600, Aurora, CO 80014",
    distance: "Located in Aurora, CO — approximately 540 miles east of Layton via I-80",
  },
  nearbyCitiesZips: [
    { name: "Layton", zips: "84040, 84041" },
    { name: "Ogden", zips: "84401, 84403, 84404, 84405" },
    { name: "Clearfield", zips: "84015, 84016, 84089" },
    { name: "Bountiful", zips: "84010, 84011" },
    { name: "Syracuse", zips: "84075" },
    { name: "Roy", zips: "84067" },
    { name: "Kaysville", zips: "84037" },
    { name: "Farmington", zips: "84025" },
    { name: "Centerville", zips: "84014" },
    { name: "West Point", zips: "84015" },
    { name: "Clinton", zips: "84015" },
    { name: "Sunset", zips: "84015" },
    { name: "South Weber", zips: "84405" },
    { name: "Fruit Heights", zips: "84037" },
    { name: "North Salt Lake", zips: "84054" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Davis County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Hill AFB Gateway", desc: "Serving Layton, Clearfield, Hill AFB, and northern Davis County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Ogden, UT", route: "/cities/ogden" },
    { name: "Fast passport renewal in Salt Lake City, UT", route: "/cities/salt-lake-city" },
    { name: "Emergency passport help in Logan, UT", route: "/cities/logan" },
    { name: "Urgent passport services in Provo, UT", route: "/cities/provo" },
    { name: "Same-day passport help in Denver, CO", route: "/cities/denver" },
    { name: "Passport courier services in St. George, UT", route: "/cities/st-george" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Layton remotely via secure courier. We do not have a walk-in office in Layton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Davis County and the northern Wasatch Front.",
  fpcOfficeAddress: "299 S Main St, Salt Lake City, Utah 84111",
  fpcOfficeDistance: "Serving all of Davis County and the northern Wasatch Front including Weber, Morgan, and Box Elder counties",
  serviceAreaIntro: "From the Layton Hills Mall and the Hill Air Force Base military community to the family-friendly neighborhoods of Kaysville and Fruit Heights, from the waterfront communities of Syracuse and West Point along the Great Salt Lake to the historic downtown of Farmington and the Bountiful bench, from the railroad town of Clearfield to the growing suburbs of Clinton and Sunset — Fast Passport Center serves the entire Davis County and northern Wasatch Front region. We regularly help travelers from Davis County, Weber County, and surrounding areas get their passports fast without the 540-mile drive to Denver.",
  nearbyCitiesIntro: "We serve all Layton neighborhoods and the surrounding Davis County area including Clearfield, Syracuse, Roy, Kaysville, Farmington, Bountiful, Centerville, West Point, and Clinton. If you are anywhere in Davis County or northern Weber County, we have you covered.",
  howItWorksIntro: "Most Layton travelers complete everything online and ship documents overnight. No need to drive to Denver — we handle the courier submission for you.",
  mistakesIntro: "Layton travelers often face an 8-hour drive to the nearest regional passport agency in Denver. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Layton and Davis County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Layton? Here are the most common ones we hear from Davis County travelers.",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (Utah Vital Records)", url: "https://vitalrecords.utah.gov/", desc: "Utah Department of Health — Office of Vital Records for birth and death certificates statewide" },
    { label: "Marriage Licenses (Davis County Clerk)", url: "https://www.daviscountyutah.gov/clerk-auditor", desc: "Davis County Clerk for Layton and Davis County" },
    { label: "Divorce Decrees (Davis County District Court)", url: "https://www.utcourts.gov/courts/dist/", desc: "Davis County District Court for divorce decree records" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Utah vital records online via VitalChek" },
  ],
  statePageRoute: "/states/utah",
  statePageName: "Utah",
  dmvWebsite: "https://dmv.utah.gov",
  dmvLabel: "Utah DMV — Division of Motor Vehicles",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Layton travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sergeant First Class David K.",
      location: "Layton, UT (Hill AFB)",
      rating: 5,
      text: "PCS orders to Ramstein, Germany with 10 days notice. Fast Passport Center got our family of four emergency passports in 34 hours. Hill AFB families — this is the service you need for OCONUS PCS.",
      service: "Emergency Passport",
    },
    {
      name: "Amanda L.",
      location: "Syracuse, UT",
      rating: 5,
      text: "Our 20th anniversary trip to Paris was 5 days away and my husband's passport was expired. Fast Passport Center renewed it in 26 hours. Never left Davis County. Best anniversary gift ever.",
      service: "Passport Renewal",
    },
    {
      name: "Kevin J.",
      location: "Kaysville, UT",
      rating: 5,
      text: "My daughter's passport was lost the week before her mission trip to Guatemala. Fast Passport Center replaced it in 30 hours. Incredible service for Davis County families. Truly saved the trip.",
      service: "Lost or Stolen Passport",
    },
  ],
  facilities: [
    {
      id: "layton-ut-1",
      name: "Layton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1175 E Gentile St",
      city: "Layton",
      state: "UT",
      zip: "84041",
      phone: "(801) 546-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Layton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Layton facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "layton-ut-2",
      name: "Davis County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "28 E State St",
      city: "Farmington",
      state: "UT",
      zip: "84025",
      phone: "(801) 451-3213",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "8 miles south of Layton — Davis County Courthouse",
      website: "https://www.daviscountyutah.gov/clerk-auditor",
      websiteLabel: "Davis County Clerk",
      notes: "Primary Davis County passport acceptance center. Appointments recommended. Serves entire county including Layton.",
      icon: "ri-government-line",
    },
    {
      id: "layton-ut-3",
      name: "Clearfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "127 S 500 E",
      city: "Clearfield",
      state: "UT",
      zip: "84015",
      phone: "(801) 825-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "4 miles north of Layton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hill AFB personnel and Clearfield residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "layton-ut-4",
      name: "Bountiful Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 S Main St",
      city: "Bountiful",
      state: "UT",
      zip: "84010",
      phone: "(801) 292-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles south of Layton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bountiful and southern Davis County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "layton-ut-5",
      name: "Syracuse Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1739 S 2000 W",
      city: "Syracuse",
      state: "UT",
      zip: "84075",
      phone: "(801) 774-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of Layton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Syracuse and West Point areas. Call ahead for passport appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Denver", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Layton photo shops sometimes use retail or outdoor backgrounds. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Davis County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Layton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Denver regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-shield-user-line",
      title: "Military PCS Passport Confusion",
      description: "Hill AFB families on PCS orders often confuse no-fee official passports with tourist passports. Make sure you apply for the correct type for personal travel.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Layton travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Layton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Layton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Layton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Layton for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Denver." },
    { q: "How fast can I renew my passport in Layton?", a: "Fast Passport Center offers fast passport renewal in Layton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Layton?", a: "The nearest regional passport agency to Layton is the Denver Passport Agency, approximately 540 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Layton without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Layton?", a: "Same-day passport appointments are only available at the Denver Regional Passport Agency — approximately 8 hours from Layton — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Davis County residents." },
    { q: "Do you help Hill AFB families with PCS passport needs?", a: "Absolutely. Fast Passport Center serves military families at Hill Air Force Base with emergency and expedited passport services. We have extensive experience helping service members and their families get tourist passports fast for OCONUS PCS moves, leave travel, and TDY assignments. Our courier service works seamlessly from base housing or off-base Davis County addresses." },
    { q: "Can I expedite a child passport in Layton?", a: "Yes. Fast Passport Center expedites child passports in Layton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Davis County families — including military families — through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Layton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Denver Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Layton", address: "745 W Hill Field Rd, Layton, UT 84041", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Layton", address: "1500 N Main St, Layton, UT 84041", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Clearfield", address: "1215 S State St, Clearfield, UT 84015", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Costco — Layton", address: "1245 E 900 N, Layton, UT 84040", hours: "Mon–Sun: 9AM–8:30PM" },
  ],
  dmvLocations: [
    {
      name: "Utah DMV — Layton",
      address: "2980 N Main St, Layton, UT 84041",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended. Central Davis County location.",
      featured: true,
    },
    {
      name: "Utah DMV — Ogden",
      address: "2447 Lincoln Ave, Ogden, UT 84401",
      hours: "Mon–Fri: 7AM–5PM",
      note: "Serves Weber County. REAL ID available. About 15 minutes north of Layton.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SLC",
      name: "Salt Lake City International Airport",
      distance: "25 miles south of Layton",
      address: "776 N Terminal Dr, Salt Lake City, UT 84122",
      note: "Major international airport with direct flights worldwide. About 30 minutes from Layton via I-15.",
      flightUrl: "https://www.slcairport.com/",
      flightLabel: "SLC Airport",
      featured: true,
    },
    {
      code: "OGD",
      name: "Ogden-Hinckley Airport",
      distance: "12 miles north of Layton",
      address: "3909 Airport Rd, Ogden, UT 84405",
      note: "Regional airport with limited commercial service via Breeze Airways. About 20 minutes from Layton.",
      flightUrl: "https://www.flyogden.com/",
      flightLabel: "OGD Airport",
      featured: false,
    },
  ],
};